export default __webpack_public_path__ + "static/char-37-anr-2ac010e65c537693ee027dc5b2d6ac56.gif";